import { formatLocaleDate } from '@evidentid/ido-lib/formatLocaleDate';

import { CriminalOffenseDate } from '@/interfaces/OffenseCategory';

function formatCriminalOffenseDate(date: CriminalOffenseDate | null): string {
    if (!date) {
        return 'Date Not Found';
    }

    return formatLocaleDate(new Date(date.year, date.month, date.day));
}

export default formatCriminalOffenseDate;
